import React from 'react'
import ContentLoader from 'react-content-loader'

const MyLoader = props => (
  <ContentLoader
    speed={2}
    width={415}
    height={650}
    viewBox="0 0 415 650"
    backgroundColor="#e6e6e6"
    foregroundColor="#cdcdcd"
    {...props}
  >
    <circle cx="72" cy="31" r="20" />
    <circle cx="159" cy="31" r="20" />
    <circle cx="254" cy="31" r="20" />
    <circle cx="343" cy="31" r="20" />
    <rect x="41" y="69" rx="5" ry="5" width="60" height="10" />
    <rect x="130" y="69" rx="5" ry="5" width="60" height="10" />
    <rect x="223" y="69" rx="5" ry="5" width="60" height="10" />
    <rect x="315" y="69" rx="5" ry="5" width="60" height="10" />
    <rect x="99" y="106" rx="5" ry="5" width="205" height="15" />
    <rect x="20" y="132" rx="5" ry="5" width="360" height="2" />
    <rect x="20" y="146" rx="5" ry="5" width="360" height="8" />
    <rect x="20" y="163" rx="5" ry="5" width="360" height="8" />
    <rect x="20" y="179" rx="5" ry="5" width="360" height="8" />
    <rect x="20" y="196" rx="5" ry="5" width="360" height="8" />
    <rect x="150" y="227" rx="14" ry="14" width="100" height="24" />
    <rect x="86" y="282" rx="5" ry="5" width="230" height="15" />
    <rect x="20" y="309" rx="5" ry="5" width="360" height="2" />
    <rect x="18" y="318" rx="0" ry="0" width="270" height="195" />
    <rect x="293" y="318" rx="0" ry="0" width="95" height="95" />
    <rect x="293" y="418" rx="0" ry="0" width="95" height="95" />
  </ContentLoader>
)

export default MyLoader
